'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
cbStripEtalageV1Controller.$inject = ['$attrs'];
var _module = angular.module('cb.strips.cb-strip-etalage-v1.cbStripEtalageV1Controller', []);

_module.controller('cbStripEtalageV1Controller', cbStripEtalageV1Controller);

exports.default = _module;


function cbStripEtalageV1Controller($attrs) {
    var vm = this;
    vm.toggleContainer = toggleContainer;

    vm.$onInit = function () {
        toggleContainer($attrs.cbStripEtalageDefault);
    };

    function toggleContainer(option) {
        vm.containerActive = option;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/etalage-v1/etalage.controller.js
// module id = 939
// module chunks = 1